import * as React from 'react';

interface Props {
  readonly value?: string | string[] | number;
  readonly onChange?: any;
  readonly onKeyDown?: any;
  readonly placeholder?: string;
  readonly style?: any;
  readonly className?: string;
  readonly type?: string;
}

class BelfiusTextInput extends React.Component<Props> {
  render() {
    return (
      <input {...this.props} />
    );
  }
}

export { BelfiusTextInput };
